import { z } from 'zod';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { useMaxCharacters } from './useMaxCharacters';

export function useRequiredEmail() {
    const { t } = useServerTranslation();
    const maxCharacters = useMaxCharacters();

    return (message: string, badFormat: string, max?: number) => {
        const email = z.string({
            required_error: t(message),
            invalid_type_error: t(message),
        }).email({ message: t(badFormat) });

        return maxCharacters(email, max);
    };
}
